var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyMsgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 84,
    viewBox: "0 0 189 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.271 0.359375H20.9091C9.36134 0.359375 0 9.72071 0 21.2685V63.0868C0 74.6346 9.36134 83.996 20.9091 83.996H167.271C178.819 83.996 188.18 74.6346 188.18 63.0868V21.2685C188.18 9.72071 178.819 0.359375 167.271 0.359375Z",
    fill: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4963 25.1137C55.3757 25.1137 53.6484 23.3887 53.6484 21.2658C53.6484 19.143 55.3734 17.418 57.4963 17.418H151.586C153.707 17.418 155.434 19.143 155.434 21.2658C155.434 23.3887 153.709 25.1137 151.586 25.1137H57.4963Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4963 46.0239C55.3757 46.0239 53.6484 44.2989 53.6484 42.176C53.6484 40.0531 55.3734 38.3281 57.4963 38.3281H172.495C174.616 38.3281 176.343 40.0531 176.343 42.176C176.343 44.2989 174.618 46.0239 172.495 46.0239H57.4963Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4963 66.9321C55.3757 66.9321 53.6484 65.2071 53.6484 63.0842C53.6484 60.9613 55.3734 59.2363 57.4963 59.2363H125.449C127.57 59.2363 129.297 60.9613 129.297 63.0842C129.297 65.2071 127.572 66.9321 125.449 66.9321H57.4963Z",
    fill: "#CCCCCC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.972 16.0195H19.4139C16.768 16.0195 14.623 18.1645 14.623 20.8104V38.3685C14.623 41.0144 16.768 43.1593 19.4139 43.1593H36.972C39.6179 43.1593 41.7628 41.0144 41.7628 38.3685V20.8104C41.7628 18.1645 39.6179 16.0195 36.972 16.0195Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMsgLogo);
export default __webpack_public_path__ + "static/media/emptyMsg_logo.c41ba8ebf9b8b318e7f8f7232b2273e3.svg";
export { ForwardRef as ReactComponent };